/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';
import type { ListCompanies200ResponseItemsInner } from './ListCompanies200ResponseItemsInner';
import {
    ListCompanies200ResponseItemsInnerFromJSON,
    ListCompanies200ResponseItemsInnerFromJSONTyped,
    ListCompanies200ResponseItemsInnerToJSON,
    ListCompanies200ResponseItemsInnerToJSONTyped,
} from './ListCompanies200ResponseItemsInner';

/**
 * 
 * @export
 * @interface ListCompanies200Response
 */
export interface ListCompanies200Response {
    /**
     * 
     * @type {Array<ListCompanies200ResponseItemsInner>}
     * @memberof ListCompanies200Response
     */
    items: Array<ListCompanies200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof ListCompanies200Response
     */
    paging: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the ListCompanies200Response interface.
 */
export function instanceOfListCompanies200Response(value: object): value is ListCompanies200Response {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('paging' in value) || value['paging'] === undefined) return false;
    return true;
}

export function ListCompanies200ResponseFromJSON(json: any): ListCompanies200Response {
    return ListCompanies200ResponseFromJSONTyped(json, false);
}

export function ListCompanies200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCompanies200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ListCompanies200ResponseItemsInnerFromJSON)),
        'paging': ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function ListCompanies200ResponseToJSON(json: any): ListCompanies200Response {
    return ListCompanies200ResponseToJSONTyped(json, false);
}

export function ListCompanies200ResponseToJSONTyped(value?: ListCompanies200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(ListCompanies200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

